import { Routes, Route } from "react-router-dom";
import OrganizationsList from "./OrganizationsList";
import OrganizationForm from "./OrganizationForm";
import OrganizationDetail from "./OrganizationDetail";

export default function OrganizationsRoutes() {
  return (
    <Routes>
      <Route index element={<OrganizationsList />} />
      <Route path="new" element={<OrganizationForm />} />
      <Route path=":id/edit" element={<OrganizationForm />} />
      <Route path=":id" element={<OrganizationDetail />} />
    </Routes>
  );
}
